export const i18nLocales = ["en", "fr", "es", "de-DE"] as const;
export type SupportedLocale = (typeof i18nLocales)[number];
export const ALL_VALUE = "ALL" as const;
export const EMPTY_VALUE = " - " as const;
export const ALL_SYMBOL = "*" as const;
export const MAX_MAX_RESULT_COUNT = 1000 as const;
export const BRAND_FILTER_QUERY_KEY = "brandFilter" as const;
export const REGION_FILTER_QUERY_KEY = "regionFilter" as const;
export const SEARCH_FILTER_QUERY_KEY = "search" as const;
